import { FC } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { ReactComponent as MinusIcon } from 'src/assets/svg/minus.svg';
import { ReactComponent as PlusIcon } from 'src/assets/svg/plus.svg';
import { getTheme } from 'src/utils/getTheme';

import { styles } from './styles';

const { theme, isHosTheme } = getTheme();

interface StudentCounterProps {
    value: number;
    min: number;
    max: number;
    onChange: (value: number) => void;
}

export const StudentCounter: FC<StudentCounterProps> = ({ value, min, max, onChange }) => {
    const { t } = useTranslation();

    const canDecrement = value > min;
    const canIncrement = value < max;

    const getIconColor = (isEnabled: boolean) => {
        if (!isEnabled) return theme.palette.text.disabled;

        return isHosTheme ? theme.palette.secondary.dark : theme.palette.text.secondary;
    };

    return (
        <Box css={styles.studentCounter}>
            <Typography variant="h4">
                {t('booking_summary_booking_details_student_number_subtitle')}
            </Typography>
            <Box css={styles.counter}>
                <button
                    type="button"
                    css={[styles.counterButton, !canDecrement && styles.counterButtonDisabled]}
                    onClick={() => onChange(value - 1)}
                    disabled={!canDecrement}
                    aria-label={t('view_room_remove_student')}
                    id="view-room-decrement-students"
                >
                    <MinusIcon color={getIconColor(canDecrement)} />
                </button>
                <Typography variant="h4" aria-live="polite">
                    {value}
                </Typography>
                <button
                    type="button"
                    css={[styles.counterButton, !canIncrement && styles.counterButtonDisabled]}
                    onClick={() => onChange(value + 1)}
                    disabled={!canIncrement}
                    aria-label={t('view_room_add_student')}
                    id="view-room-increment-students"
                >
                    <PlusIcon color={getIconColor(canIncrement)} />
                </button>
            </Box>
        </Box>
    );
};
